import { AxiosConfig } from './axiosConfig';

export class CriarCheckboxDeClientes {

    constructor() {
        this._axios      = (new AxiosConfig()).instanciaAxios();
        this._clientesId = [];
    }

    /**
     *
     * @param {int[]} arrayRastreaviesId
     * @returns {CriarCheckboxDeRastreaveis}
     */
    selecionarCheckbox(arrayRastreaviesId) {
        if (Array.isArray(arrayRastreaviesId)) {
            this._clientesId = arrayRastreaviesId;
        }

        return this;
    }

    /**
     * @param  {HTMLElement} htmlElement
     * @return {void}
     */
    criar(htmlElement) {
        this._axios.get(this._montarUrlConsulta())
        .then((response) => {
            if (Array.isArray(response.data) && response.data.length > 0) {
                htmlElement.innerHTML = this._criarCheckBox(response.data);
                return;
            }

            htmlElement.innerHTML = 'Nenhum cliente encontrado';
        })
        .catch((error) => {
            console.log(error);
        });
    }

    /**
     * @param {array} clientes
     * @return {string}
     * @private
     */
    _criarCheckBox(clientes) {
        let listaCheckbox = '<input name="clientes" type="hidden" value="">';
        clientes.forEach((cliente) => {
            const checked = this._clientesId?.includes(cliente.id) ? 'checked' : '';

            listaCheckbox += `
                <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-4 pl-0 pb-10">
                    <div class="form-check abc-checkbox abc-checkbox-info">
                        <input name="clientes[]" type="checkbox" id="id-${cliente.id}" ${checked} value="${cliente.id}" class="form-check-input">
                        <label for="id-${cliente.id}" class="form-check-label">
                            ${cliente.nome}
                        </label>
                    </div>
                </div>
            `;
        });

        return listaCheckbox;
    }

    /**
     * Url para buscar os clientes.
     *
     * @private
     * @return  {string}
     */
    _montarUrlConsulta () {
        const urlSistema  = `${window.location.protocol}//${window.location.host}/clientes/json`;
        const camposBusca = 'campos[cliente]=id,nome';
        let filtroBusca   = `status=1&qtdRegistros=1000000`;

        return `${urlSistema}?${camposBusca}&${filtroBusca}`;
    }
}
